/* tslint:disable */
/* eslint-disable */
/**
 * Order Portal
 * Order Portal
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResultDto
 */
export interface ResultDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultDto
     */
    data: Array<string>;
}

/**
 * Check if a given object implements the ResultDto interface.
 */
export function instanceOfResultDto(value: object): value is ResultDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResultDtoFromJSON(json: any): ResultDto {
    return ResultDtoFromJSONTyped(json, false);
}

export function ResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'],
    };
}

export function ResultDtoToJSON(json: any): ResultDto {
    return ResultDtoToJSONTyped(json, false);
}

export function ResultDtoToJSONTyped(value?: ResultDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'],
    };
}

